var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',_vm._l((_vm.ads),function(add){return _c('div',{key:add.id},[_c('VueScriptComponent',{attrs:{"script":add.adcode}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }